import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { LanguageProvider } from "@/i18n/LanguageContext";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById("root");
const app = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// react-snap prerenders static HTML for crawlers & instant first paint. Because the
// site is animation-heavy (framer-motion mutates styles on mount), we client-render
// fresh over the snapshot instead of hydrating — this avoids hydration mismatches and
// lets entrance animations play as intended. Crawlers with JS disabled still get the
// full prerendered HTML + structured data.
if (rootEl.hasChildNodes()) rootEl.innerHTML = "";
ReactDOM.createRoot(rootEl).render(app);
